import FirebaseContext from "../firebase/firebaseContext";
import React, { useContext, useState, useEffect } from "react";

const Login = props => {
  const firebaseContext = useContext(FirebaseContext);
  const { auth } = firebaseContext;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userInfo, setUserInfo] = useState("");
  const [user, setUser] = useState({ authenticated: false });

  const onLogin = e => {
    e.preventDefault();
    firebaseContext.login(email, password);
    props.history.push("/");
  };

  const authListen = setUser => {
    return auth.onAuthStateChanged(user => {
      if (user) {
        setUser({ authenticated: true });
        setUserInfo({ email: user.email });
      } else {
        setUser({ authenticated: false });
      }
    });
  };

  useEffect(() => {
    const unsubscribe = async () => {
      await authListen(setUser);
      console.log(user);
    };
    unsubscribe();
  }, []);

  return (
    <div>
      <div className='login-container'>
        <form onSubmit={e => onLogin(e)}>
          <input
            type='text'
            className='form-input'
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder='email'
          />
          <input
            type='text'
            className='form-input'
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder='password'
          />
          <button type='submit' className='form-button'>
            Submit
          </button>

          <p>Zavihek "Vpiši se" je namenjen učiteljem.</p>
          <p>UČENCI SE NE VPISUJETE</p>

          <div></div>
        </form>
      </div>
    </div>
  );
};

export default Login;
